function customYoutubeVideoPlayOnClick(flag){
        var link = '{{ section.settings.videoUrl | append:"?enablejsapi=1&autoplay=1" }}';
        var videoHtml = '<iframe width="100%" height="100%" src="' + link + '" class="youtube-player youtubeVideo  customYoutubeVideo" frameborder="0" allow="autoplay;" autoplay="1"></iframe>';

        $(".customYoutubeVideoIframe").prepend(videoHtml);


        $("#customYoutubeVideoIframePopupShowDiv-"+flag).show();
        console.log($("#player").length)
        $("#player .ytp-large-play-button.ytp-button.ytp-large-play-button-red-bg").trigger('click');

    }

    $(".customYoutubeVideoIframePopupShow-video-close").click(function() {
        $(".customYoutubeVideoIframePopupShowDiv").hide();
        $(".customYoutubeVideo").remove();
    })